// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-CurrentSongRequestDescription-module__description-uBCry {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 8px;
}

@media (min-width: 768px) {

.nightbot-CurrentSongRequestDescription-module__description-uBCry {
    align-self: center;
}

  }

.nightbot-CurrentSongRequestDescription-module__requestedBy-ytb2f {
  --text-color: var(--text-secondary);
}

.nightbot-CurrentSongRequestDescription-module__badgeContainer-XgGTv {
  display: flex;
  gap: 16px;
  align-items: center;
}

.nightbot-CurrentSongRequestDescription-module__title-WUSTQ {
  font-weight: 600;
  font-size: var(--mantine-font-size-xl);
  white-space: pre-wrap;
  color: var(--text-primary);
}

@media (max-width: 768px) {

.nightbot-CurrentSongRequestDescription-module__title-WUSTQ {
    font-size: var(--mantine-font-size-sm);
}
  }

.nightbot-CurrentSongRequestDescription-module__emptyDescription-_zUiK {
  flex: 1;
}

.nightbot-CurrentSongRequestDescription-module__artistContainer-II8uF {
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: var(--mantine-font-size-sm);
  color: var(--text-secondary);
}`, "",{"version":3,"sources":["webpack://./src/components/song_requests/CurrentSongRequestDescription.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,QAAQ;AAOV;;AAJE;;AAPF;IAQI,kBAAkB;AAGtB;;EADE;;AAGF;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,qBAAqB;EACrB,0BAA0B;AAK5B;;AAHE;;AANF;IAOI,sCAAsC;AAE1C;EADE;;AAGF;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,sCAAsC;EACtC,4BAA4B;AAC9B","sourcesContent":[".description {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  gap: 8px;\n\n\n  @media (min-width: $mantine-breakpoint-sm) {\n    align-self: center;\n\n  }\n}\n\n.requestedBy {\n  --text-color: var(--text-secondary);\n}\n\n.badgeContainer {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.title {\n  font-weight: 600;\n  font-size: var(--mantine-font-size-xl);\n  white-space: pre-wrap;\n  color: var(--text-primary);\n\n  @media (max-width: $mantine-breakpoint-sm) {\n    font-size: var(--mantine-font-size-sm);\n  }\n}\n\n.emptyDescription {\n  flex: 1;\n}\n\n.artistContainer {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  font-size: var(--mantine-font-size-sm);\n  color: var(--text-secondary);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": `nightbot-CurrentSongRequestDescription-module__description-uBCry`,
	"requestedBy": `nightbot-CurrentSongRequestDescription-module__requestedBy-ytb2f`,
	"badgeContainer": `nightbot-CurrentSongRequestDescription-module__badgeContainer-XgGTv`,
	"title": `nightbot-CurrentSongRequestDescription-module__title-WUSTQ`,
	"emptyDescription": `nightbot-CurrentSongRequestDescription-module__emptyDescription-_zUiK`,
	"artistContainer": `nightbot-CurrentSongRequestDescription-module__artistContainer-II8uF`
};
export default ___CSS_LOADER_EXPORT___;
